/* unplugin-vue-components disabled */import { render } from "./threeMap.vue?vue&type=template&id=4788f77b&scoped=true"
import script from "./threeMap.vue?vue&type=script&lang=js"
export * from "./threeMap.vue?vue&type=script&lang=js"

import "./threeMap.vue?vue&type=style&index=0&id=4788f77b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4788f77b"]])

export default __exports__